<template>
  <div ref="spot" :class="[$style['spot'], on && $style['spot--on']]" aria-hidden="true" />
</template>
<script setup lang="ts">
// A soft warm follow-spot that tracks the mouse across the dark parts of the page
const spot = ref<HTMLElement>()
const on = ref(false)

function onMove (event: PointerEvent) {
  spot.value?.style.setProperty('--x', `${event.clientX}px`)
  spot.value?.style.setProperty('--y', `${event.clientY}px`)
  on.value = true
}

onMounted(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (finePointer && !reduce) window.addEventListener('pointermove', onMove, { passive: true })
})

onBeforeUnmount(() => window.removeEventListener('pointermove', onMove))
</script>
<style module>
.spot {
  position: fixed;
  inset: 0;
  z-index: 900;
  pointer-events: none;
  opacity: 0;
  transition: opacity 400ms;
  background:
    radial-gradient(
      circle 22rem at var(--x, 50%) var(--y, 50%),
      oklch(90% 0.07 75deg / 13%),
      oklch(90% 0.07 75deg / 0%) 70%
    );
  mix-blend-mode: screen;
}

.spot--on {
  opacity: 1;
}
</style>
